import { render, staticRenderFns } from "./shoppingMallS.vue?vue&type=template&id=af4ef494&scoped=true&"
import script from "./shoppingMallS.vue?vue&type=script&lang=js&"
export * from "./shoppingMallS.vue?vue&type=script&lang=js&"
import style0 from "./shoppingMallS.vue?vue&type=style&index=0&id=af4ef494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ef494",
  null
  
)

export default component.exports